// SkillFoot animations — idempotent guard so multi-include doesn't re-bind observers.
(function () {
  if (window.__sfAnimationsLoaded) return;
  window.__sfAnimationsLoaded = true;

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealAll = () => {
    document.querySelectorAll('.sf-reveal:not(.sf-reveal--visible)').forEach((el) => {
      el.classList.add('sf-reveal--visible');
    });
  };

  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealAll();
  } else {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('sf-reveal--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );
    document.querySelectorAll('.sf-reveal').forEach((el) => observer.observe(el));
    window.__sfRevealObserver = observer;
  }

  const initStagger = (root = document) => {
    root.querySelectorAll('[data-sf-stagger]').forEach((container) => {
      if (container.dataset.sfStaggerInit === '1') return;
      container.dataset.sfStaggerInit = '1';
      const step = parseInt(container.dataset.sfStagger, 10) || 80;
      Array.from(container.children).forEach((child, i) => {
        child.style.transitionDelay = `${i * step}ms`;
      });
    });
  };
  initStagger();

  // Re-init when sections reload in the theme editor.
  document.addEventListener('shopify:section:load', (e) => {
    initStagger(e.target);
    if (window.__sfRevealObserver) {
      e.target.querySelectorAll('.sf-reveal:not(.sf-reveal--visible)').forEach((el) => {
        window.__sfRevealObserver.observe(el);
      });
    } else {
      e.target.querySelectorAll('.sf-reveal').forEach((el) => el.classList.add('sf-reveal--visible'));
    }
  });
})();
